import axios from 'axios';
// import { API } from '../../../api/config/api'
import store from '../../../store'

// var urlsApi = API
// var response = JSON.parse(localStorage.getItem('response')) 
// console.log('response => ', response)
// let urlsApi = response ? response.Empresas[localStorage.getItem('INDEXEMPRESA')].api : ''

export class resourceCampanhas {
  static getListaCampanhas () {
    return axios.get(store.state.api + 'cupons?empresa=' + store.state.empresa_fb_id  )
  }
  static getCampanhaByID (id) {
    return axios.get(store.state.api + 'cupons/' + id)
  }
  static updateCampanha (obj, id) {
    return axios.put(store.state.api + 'cupons/' + id, obj)
  }
  static gravarCampanha (obj) {
    return axios.post(store.state.api + 'cupons', obj)
  }
  static aprovar(id) {
    return axios.get(store.state.api + 'campanhas/aprovar?campanha=' + id )
  }
  static reprovar(id) {
    return axios.get(store.state.api + 'campanhas/reprovar?campanha=' + id )
  }
  static restartAll() {
    return axios.get('https://clarim.herokuapp.com/restart-all?empresa=' + store.state.empresa_fb_id)
  }
}

export default resourceCampanhas



// WEBPACK FOOTER //
// ./src/components/views/Campanhas/resource.js